import React, { useEffect, useState } from "react";

import { Card, Pagination } from "../components";
import { jobsPageQuery, partTimeQuery, fullTimeQuery, totalOpenings, totalFtOpenings, totalPtOpenings } from "../utils/Data";
import { client } from '../client'
import { useNavigate } from "react-router-dom";
import { searchPath } from "../utils/searchPath";
import { feature } from "../utils/features";
import { LoadingBlock, LoadingOverlay } from "../components/Spinner";

// Refreshed search bar on boards with the new cards (feature "modernCards"); others keep the classic one.
const MODERN = feature("modernCards");
const css = (classic, modern) => (MODERN ? modern : classic);





function JobCardRender(job) {

  return (
    <Card
      key={job._id}
      btnId={job._id}
      title={job.title}
      companyName={job.companyName}
      categories={job.categories}
      city={job.city}
      salary={job.salary}
      postedOn={job.postedOn}
      externalUrl={job.url}
      source={job.source}
      postExpiry={job.postExpiry}
    />
  );
}




function Jobs() {

  const [currentPage, setCurrentPage] = useState(0)
  const [maxOpenings, setMaxOpenings] = useState()
  const [searchTerm, setSearchTerm] = useState("");
  const [searchLocation, setSearchLocation] = useState("");
  const navigate = useNavigate();

  function handleSearch(e) {
    e.preventDefault();
    navigate(searchPath(searchTerm, searchLocation));
  }
  const [jobsArr, setJobsArr] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fullTimeFilter, setFullTimeFilter] = useState(false)
  const [partTimeFilter, setPartTimeFilter] = useState(false)

  function checkFilter(){
    let fulltime = document.getElementById('fulltime')
    let parttime = document.getElementById('parttime')

    if(fulltime.checked == true){
      setFullTimeFilter(true)
      setCurrentPage(0)
    }else if (fulltime.checked == false){
      setFullTimeFilter(false)
      setCurrentPage(0)
    }

    if(parttime.checked == true){
      setPartTimeFilter(true)
    }else if (parttime.checked == false){
      setPartTimeFilter(false)
    }

  }

  function activePageinc (){
    if(currentPage < ((maxOpenings/10)-1))
      { setCurrentPage(currentPage+1); window.scrollTo({ top: 0, behavior: "smooth" }); }
  }

  function activePagedec(){

    if(currentPage != 0 ) {
      { setCurrentPage(currentPage-1); window.scrollTo({ top: 0, behavior: "smooth" }); }
    }
    
  }

  useEffect(()=>{
    if((partTimeFilter == false && fullTimeFilter == false) || (partTimeFilter == true && fullTimeFilter == true)){
      //job cards
      setLoading(true);
      client.fetch(jobsPageQuery(currentPage)).then((jobs) => {
        setJobsArr(jobs);
      }).catch((err) => console.log(err)).finally(() => setLoading(false));
      //total
      client.fetch(totalOpenings)
      .then((res)=>setMaxOpenings(res)).catch((err) => console.log(err));

    } else if((partTimeFilter == false && fullTimeFilter == true)){
      //jobs
      setLoading(true);
      client.fetch(fullTimeQuery(currentPage)).then((jobs) => {
        setJobsArr(jobs);
      }).catch((err) => console.log(err)).finally(() => setLoading(false));

      //total
      client.fetch(totalFtOpenings)
      .then((res)=>setMaxOpenings(res)).catch((err) => console.log(err));


    }else if((partTimeFilter == true && fullTimeFilter == false)){
      setLoading(true);
      client.fetch(partTimeQuery(currentPage)).then((jobs) => {
        setJobsArr(jobs);
      }).catch((err) => console.log(err)).finally(() => setLoading(false));

      client.fetch(totalPtOpenings)
      .then((res)=>setMaxOpenings(res)).catch((err) => console.log(err));
    }
    
    
  },[fullTimeFilter, partTimeFilter,currentPage])
  
   
  

  return (
    <div className="scroll-smooth">
      <section className="md:px-8 md:mx-8 py-4 ">
        
        {/* Search Component */}
        <form
          role="search"
          onSubmit={handleSearch}
          className={css("flex md:flex-row flex-col w-full justify-between items-center md:items-end  md:px-8 md:mx-8  ", "mx-auto mt-6 flex max-w-6xl flex-col gap-2 rounded-2xl bg-white p-2 shadow-md ring-1 ring-gray-200 sm:flex-row")}
        >
        <div className={css("relative flex md:flex-row flex-col md:mr-4 w-4/5 mx-auto md:w-full lg:w-full items-center mt-4 ", "flex flex-1 flex-col gap-2 sm:flex-row")}>
          <input
          onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Job title, keywords, or company"
            aria-label="Job title, keywords, or company"
            type="text"
            id="jobs-term"
            name="term"
            className={css("w-full bg-gray-100 rounded border bg-opacity-50 border-gray-200 focus:ring-2 focus:ring-indigo-200 focus:bg-transparent focus:border-primary text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out", "w-full rounded-xl border-0 bg-gray-50 px-4 py-3 text-base text-gray-800 outline-none focus:ring-2 focus:ring-primary")}
          />
          <input
          onChange={(e) => setSearchLocation(e.target.value)}
            placeholder="City, or Province"
            aria-label="City, or Province"
            type="text"
            id="jobs-location"
            name="location"
            className={css("w-full md:ml-4 md:mt-0 mt-4 bg-gray-100 rounded border bg-opacity-50 border-gray-200 focus:ring-2 focus:ring-indigo-200 focus:bg-transparent focus:border-primary text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out", "w-full rounded-xl border-0 bg-gray-50 px-4 py-3 text-base text-gray-800 outline-none focus:ring-2 focus:ring-primary")}
          />
        </div>
        <button type="submit" className={css("inline-flex mt-4 md:mt-0 text-white font-semibold font-[Poppins] bg-primary px-6 py-1 rounded-lg border-2 border-primary hover:text-primary hover:bg-white ease-in duration-150 text-lg", "rounded-xl bg-primary px-7 py-3 font-[Poppins] text-lg text-white transition hover:opacity-90")}>
          Search
        </button>
      </form>
      <div className={css(" flex items-center mb-24 mt-4 md:px-8 md:mx-8 px-2 mx-2 justify-center", "mb-10 mt-5 flex items-center justify-center px-2 text-sm text-gray-700")}>
        <p className="mr-4 font-semibold text-gray-900">Filter:</p>
        <input
          onClick={checkFilter}
          className="mr-2 text-primary  "
          type="checkbox"
          id="fulltime"
          name="Full-Time"
         
        />
        <label className="mr-4" htmlFor="fulltime">
          Full Time
        </label>

        <input
          onClick={checkFilter}
          className="mr-2  text-primary "
          type="checkbox"
          id="parttime"
          name="Part-Time"
        />
        <label htmlFor="parttime">Part Time</label>
      </div>
        {/* Section below will need to change based on routes */}
        <div className="relative">
        {loading && jobsArr.length > 0 && <LoadingOverlay label="Loading jobs…" />}
        <div className={css("md:px-16 md:mx-16 px-2 mx-2 mb-8 ", "mx-auto mb-8 grid max-w-6xl gap-x-4 px-2 md:grid-cols-2")}>
          {loading && jobsArr.length === 0 ? <LoadingBlock label="Loading jobs…" minHeight="min-h-[24rem]" /> : jobsArr.map(JobCardRender)}
        </div>
        </div>

        {/* Pagination */}
        <Pagination 
          currentPage={currentPage}
          increment={activePageinc}
          decrement={activePagedec}
          maxOpenings={maxOpenings}

        />
      </section>
    </div>
  );
  
}

export default Jobs;
